var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPositionBalance = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7 1a1 1 0 0 1 2 0h3a2 2 0 0 1 2 2v1h-.36l2.25 9H16v1a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-1h.11l2.25-9H3.64l2.25 9H6v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-1h.11l2.25-9H2V3a2 2 0 0 1 2-2zM1.14 13h3.72L3 5.562zm10 0h3.72L13 5.562zM4 2h8a1 1 0 0 1 1 1H3a1 1 0 0 1 1-1M1 14a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm11 1a1 1 0 0 1-1-1h4a1 1 0 0 1-1 1z",
  clipRule: "evenodd"
})));
export default SvgPositionBalance;